var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 15,
    viewBox: "0 0 38 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.707159 6.67715C0.307804 6.73213 -3.46215e-07 7.07953 -3.2784e-07 7.49989C-3.07795e-07 7.95846 0.366312 8.33021 0.818182 8.33021L35.1999 8.33021L30.0047 13.5813L29.9253 13.6743C29.687 13.9989 29.7124 14.4602 30.0023 14.7556C30.3212 15.0805 30.8392 15.0816 31.1594 14.758L37.7477 8.09954C37.787 8.06141 37.8224 8.01936 37.8536 7.97401C38.0766 7.64976 38.0452 7.19994 37.7593 6.91106L31.1593 0.241931L31.0674 0.161736C30.7466 -0.0787481 30.2921 -0.0509561 30.0023 0.24446C29.6834 0.569418 29.6845 1.09514 30.0047 1.41871L35.2012 6.66957L0.818182 6.66957L0.707159 6.67715Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.f24dbb977c98b5144b3f0fc1ac995def.svg";
export { ForwardRef as ReactComponent };